import { addClass } from '@opten/dom/add-class';

const stringPlayer = 'Player';

export class IFramePlayerOptions {
	startPlayerClass?: string;
}

export class IFramePlayer {
	private _buttonElement: HTMLElement;
	private _iFrameElement: HTMLIFrameElement;
	private _options: IFramePlayerOptions = {
		startPlayerClass: 'js-player-start',
	};

	private _boundClick = this._handleClick.bind(this);

	constructor(private element: HTMLElement, options?: IFramePlayerOptions) {
		this._options = { ...this._options, ...options };

		this._buttonElement = element.getElementsByClassName(
			this._options.startPlayerClass
		)[0] as HTMLElement;

		this._iFrameElement = element.getElementsByTagName('iframe')[0];

		this._init();
	}

	private _init() {
		// init
		if (!(stringPlayer in this.element)) {
			// prevent adding event handlers twice
			if (this._buttonElement && this._iFrameElement) {
				this._buttonElement.addEventListener('click', this._boundClick);
			}
		}

		this.element[stringPlayer] = this;
	}

	private _handleClick() {
		this.play();
		this._buttonElement.removeEventListener('click', this._boundClick);
	}

	play() {
		if (this._iFrameElement.src.indexOf('autoplay') === -1) {
			this._iFrameElement.src +=
				this._iFrameElement.src.indexOf('?') === -1
					? '?autoplay=1'
					: '&autoplay=1';
			addClass(this.element, 'is-playing');
		}
	}
}

export function iframePlayer(
	element: HTMLElement,
	options?: IFramePlayerOptions
) {
	let data = element[stringPlayer] as IFramePlayer;

	if (!data) {
		data = new IFramePlayer(element, options);
	}
	return data;
}
